"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("./Utils");
/**
 * Manages a list of objects.
 * Objects may be patched. Then, they can be referenced using the 'ref' (string) property.
 */
class ObjectList {
    constructor() {
        this._items = [];
        this._refs = {};
    }
    getItems() {
        return this._items;
    }
    get first() {
        return this._items[0];
    }
    get last() {
        return this._items.length ? this._items[this._items.length - 1] : undefined;
    }
    add(item) {
        if (!this.itemInList(item)) {
            if (item.ref) {
                this._refs[item.ref] = item;
            }
            this._items.push(item);
            this.onAdd(item, this._items.length - 1);
        }
    }
    itemInList(item) {
        return this.getIndex(item) !== -1;
    }
    addAt(item, index) {
        if (index >= 0 && index <= this._items.length) {
            let currentIndex = -1;
            currentIndex = this.getIndex(item);
            if (currentIndex === index) {
                return;
            }
            if (currentIndex !== -1) {
                this.setAt(item, index);
            }
            else {
                if (item.ref) {
                    this._refs[item.ref] = item;
                }
                this._items.splice(index, 0, item);
                this.onAdd(item, index);
            }
        }
        else {
            throw new Error("addAt: The index " + index + " is out of bounds " + this._items.length);
        }
    }
    replaceByRef(item) {
        if (item.ref) {
            const existingItem = this.getByRef(item.ref);
            if (!existingItem) {
                throw new Error("replaceByRef: no item found with reference: " + item.ref);
            }
            this.replace(item, existingItem);
        }
        else {
            throw new Error("replaceByRef: no ref specified in item");
        }
        this.addAt(item, this._items.length);
    }
    replace(item, prevItem) {
        const index = this.getIndex(prevItem);
        if (index === -1) {
            throw new Error("replace: The previous item does not exist");
        }
        this.setAt(item, index);
    }
    setAt(item, index) {
        if (index >= 0 && index <= this._items.length) {
            const currentIndex = this.getIndex(item);
            if (currentIndex !== -1) {
                if (currentIndex !== index) {
                    const fromIndex = currentIndex;
                    if (fromIndex !== index) {
                        this._items.splice(fromIndex, 1);
                        this._items.splice(index, 0, item);
                        this.onMove(item, fromIndex, index);
                    }
                }
            }
            else {
                if (index < this._items.length) {
                    const ref = this._items[index].ref;
                    if (ref) {
                        this._refs[ref] = undefined;
                    }
                }
                const prevItem = this._items[index];
                // Doesn't exist yet: overwrite current.
                this._items[index] = item;
                if (item.ref) {
                    this._refs[item.ref] = item;
                }
                this.onSet(item, index, prevItem);
            }
        }
        else {
            throw new Error("setAt: The index " + index + " is out of bounds " + this._items.length);
        }
    }
    getAt(index) {
        return this._items[index];
    }
    getIndex(item) {
        return this._items.indexOf(item);
    }
    remove(item) {
        const index = this._items.indexOf(item);
        if (index !== -1) {
            this.removeAt(index);
        }
    }
    removeAt(index) {
        const item = this.removeSilently(index);
        this.onRemove(item, index);
        return item;
    }
    removeSilently(index) {
        const item = this._items[index];
        if (item.ref) {
            this._refs[item.ref] = undefined;
        }
        this._items.splice(index, 1);
        return item;
    }
    clear() {
        const n = this._items.length;
        if (n) {
            const prev = this._items;
            this._items = [];
            this._refs = {};
            this.onSync(prev, [], []);
        }
    }
    get length() {
        return this._items.length;
    }
    getRefs() {
        return this._refs;
    }
    getByRef(ref) {
        return this._refs[ref];
    }
    clearRef(ref) {
        delete this._refs[ref];
    }
    setRef(ref, child) {
        this._refs[ref] = child;
    }
    setItems(newItems) {
        const prevItems = this._items;
        this._items = newItems;
        const removedSet = new Set(prevItems);
        const added = [];
        for (let i = 0, n = newItems.length; i < n; i++) {
            const alreadyExists = removedSet.delete(newItems[i]);
            if (!alreadyExists) {
                added.push(newItems[i]);
            }
        }
        const removed = Utils_1.Utils.setToArray(removedSet);
        if (removed.length || added.length) {
            // Recalculate refs.
            this._refs = {};
            for (let i = 0, n = this._items.length; i < n; i++) {
                const ref = this._items[i].ref;
                if (ref) {
                    this._refs[ref] = this._items[i];
                }
            }
        }
        this.onSync(removed, added, newItems);
    }
    sort(f) {
        const items = this._items.slice();
        items.sort(f);
        this.onSync([], [], items);
    }
    onAdd(item, index) {
        // Noop
    }
    onRemove(item, index) {
        // Noop
    }
    onSync(removed, added, order) {
        // Noop
    }
    onSet(item, index, prevItem) {
        // Noop
    }
    onMove(item, fromIndex, toIndex) {
        // Noop
    }
}
exports.ObjectList = ObjectList;
//# sourceMappingURL=ObjectList.js.map